<div class="row">
    <div class="col-md col-lg w-100">
        <ul class="nav justify-content-center">
            <li class="nav-item">
                <a class="nav-link addNoLink" (click)="getTab(1)" [class.addBorderBottom]="isVisiblePreLimpeza">Pré
                    Limpeza</a>
            </li>
            <li class="nav-item">
                <a class="nav-link addNoLink" (click)="getTab(2)"
                    [class.addBorderBottom]="isVisibleClassificacao">Classificação</a>
            </li>
            <!-- <li class="nav-item">
                <a class="nav-link addNoLink" (click)="getTab(3)" [class.addBorderBottom]="isVisibleRepasse">Repasse</a>
            </li> -->
        </ul>
    </div>
</div>

<app-list-form-cd001-classificacao *ngIf="isVisibleClassificacao"></app-list-form-cd001-classificacao>
<app-list-form-cd001-limpeza *ngIf="isVisiblePreLimpeza"></app-list-form-cd001-limpeza>
<app-list-form-cd001-repasse *ngIf="isVisibleRepasse"></app-list-form-cd001-repasse>